/** LineChart — tier-2 adapter. */
import { useMemo } from 'react';
import { Chart, type ChartBaseProps } from './Chart';
import type { ChartConfig } from './types';

export interface LineSeries {
  /** Field name holding this series' measure. */
  key: string;
  name: string;
  color?: string;
}

export interface LineChartProps extends ChartBaseProps {
  /** Field name holding the category or time label. */
  xKey: string;
  series: readonly LineSeries[];
  title?: string;
}

export function LineChart({ xKey, series, title, ...rest }: LineChartProps) {
  const config: ChartConfig = useMemo(
    () => ({
      title,
      chartType: 'line',
      series: series.map((s) => ({
        id: s.key,
        name: s.name,
        color: s.color,
        fields: { x: xKey, y: s.key },
      })),
    }),
    [xKey, series, title],
  );
  return <Chart config={config} {...rest} />;
}
